import { writable, type Writable } from 'svelte/store';
import { isNonProductionAppBuild } from 'src/helpers/dev_tools';

const STORAGE_KEY = 'shelly_dev_show_new_layout';

const readInitialValue = (): boolean => {
	if (!isNonProductionAppBuild()) return true;
	try {
		const stored = localStorage.getItem(STORAGE_KEY);
		if (stored === null) return true;
		return stored === 'true';
	} catch {
		return true;
	}
};

/**
 * The old layout toggle has been removed from Experimental features (Labs), so
 * the new layout is now the standard, always-on experience. Non-production
 * builds can still drop back to the old layout from the Dev modal to smoke-test
 * it; the preference is local-only and production always resolves to true.
 *
 * Several call sites read this once at module init (see App.svelte), so changing
 * it only takes full effect after a reload.
 */
export const showNewLayout: Writable<boolean> = writable<boolean>(readInitialValue());

showNewLayout.subscribe((value) => {
	if (!isNonProductionAppBuild()) return;
	try {
		localStorage.setItem(STORAGE_KEY, String(value));
	} catch {
		// localStorage may be unavailable
	}
});

export const setShowNewLayout = (enabled: boolean) => {
	showNewLayout.set(isNonProductionAppBuild() ? enabled : true);
};

/**
 * Controls the New App Layout onboarding modal. Set once on app load for users
 * who haven't seen it (see MainLayoutNew), and exposed as a store so the Dev
 * modal can re-open it on demand for testing.
 */
export const showNewLayoutOnboarding: Writable<boolean> = writable<boolean>(false);
